import ReactDOM from 'react-dom'



const Modal = ( props ) => ReactDOM.createPortal( props.children, document.body  )


export default Modal
